import { createContext, useContext, useState, useCallback, lazy, Suspense, type ReactNode } from "react";
import type { Product } from "@/components/ProductCard";

const QuickBuyModal = lazy(() => import("@/components/QuickBuyModal"));

interface QuickBuyContextType {
  openQuickBuy: (product: Product, mode: "buy" | "cart") => void;
}

const QuickBuyContext = createContext<QuickBuyContextType | null>(null);

export const useQuickBuy = () => {
  const ctx = useContext(QuickBuyContext);
  if (!ctx) return { openQuickBuy: () => {} };
  return ctx;
};

export const QuickBuyProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [product, setProduct] = useState<Product | null>(null);
  const [mode, setMode] = useState<"buy" | "cart">("buy");

  const openQuickBuy = useCallback((p: Product, m: "buy" | "cart") => {
    setProduct(p);
    setMode(m);
    setIsOpen(true);
  }, []);

  return (
    <QuickBuyContext.Provider value={{ openQuickBuy }}>
      {children}
      {product && (
        <Suspense fallback={null}>
        <QuickBuyModal
          open={isOpen}
          onOpenChange={setIsOpen}
          product={product}
          mode={mode}
        />
        </Suspense>
      )}
    </QuickBuyContext.Provider>
  );
};
